export default "__VITE_ASSET__DnEGg_mV__"